import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";
import { Counter } from "folksam-ui";
import classNames from "classnames";
import { SESSION_CAM_EXCLUDE } from "constants/sessioncam";

const styles = ({ theme }) => {
  return {
    root: {
      outline: "none",
      boxSizing: "border-box",
      width: "100%",
      height: 216,
      border: 0,
      borderBottom: "2px solid",
      borderColor: ({ disabled, invalid }) =>
        `${
          disabled
            ? theme.colors.senary4
            : invalid
            ? theme.colors.tertiary2
            : "#d3c3bc"
        }`,
      boxShadow: ({ disabled }) => (disabled ? "none" : 0),
      borderRadius: theme.borderRadius.sm,
      backgroundColor: theme.colors.white,
      fontFamily: theme.fonts.serif,
      fontSize: theme.textSizes.base,
      color: ({ disabled, invalid }) =>
        invalid
          ? theme.colors.tertiary2
          : disabled
          ? theme.colors.senary3
          : "#72605e",
      lineHeight: theme.textSizes["2"],
      padding: [8, 18],
      display: "block",
      resize: "none",
      backgroundImage: `linear-gradient(to bottom, transparent 97.14286%, ${theme.colors.senary4}, ${theme.colors.senary4})`,
      backgroundPosition: "50% top",
      backgroundSize: `calc(100% - ${theme.textSizes["2"]}) ${theme.textSizes["2"]}`,
      backgroundRepeat: "repeat-y",
      transition: "all 0.1s ease-in-out",

      "&:focus, &:active": {
        borderColor: "#257886"
      },
      "&:focus::placeholder, &:active::placeholder": {
        opacity: 0.5
      }
    },
    counter: {
      marginTop: theme.margin[3],
      textAlign: "right"
    }
  };
};
const FormInputTextarea = React.forwardRef(
  (
    {
      classes,
      value,
      onChange,
      readOnly,
      disabled,
      invalid,
      counter,
      maxLength,
      sessionCamExclude,
      ...rest
    },
    ref
  ) => {
    return (
      <div>
        <textarea
          ref={ref}
          className={classNames(classes.root, {
            [SESSION_CAM_EXCLUDE]: sessionCamExclude
          })}
          value={value}
          onChange={onChange}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={maxLength}
          {...rest}
        />
        {counter ? (
          <div className={classes.counter}>
            <Counter current={value ? value.length : 0} max={maxLength} />
          </div>
        ) : null}
      </div>
    );
  }
);
FormInputTextarea.displayName = "FormInputTextarea";
FormInputTextarea.propTypes = {
  /** This is a controlled input, a value prop is required */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /** The minimum value to accept for this input */
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  /** Indicates if this field is invalid */
  invalid: PropTypes.bool,
  /** Displays a counter in the lower corner */
  counter: PropTypes.bool,
  /** Maximum input length */
  maxLength: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  /** Reference that gets passed down to the input */
  ref: PropTypes.func,
  /** Indicates if this field has been excluded from recording by sessioncam */
  sessionCamExclude: PropTypes.bool
};

FormInputTextarea.defaultProps = {
  readOnly: false,
  disabled: false,
  invalid: false
};

export default injectSheet(styles, { inject: ["classes"] })(FormInputTextarea);
